<template>
  <v-app id="sandbox" class="theme-dark">
    <main-menu v-if="appState.userLoggedIn" :drawer="primaryDrawer"></main-menu>

    <v-app-bar :clipped-left="primaryDrawer.clipped" app>
      <v-app-bar-nav-icon
        v-if="primaryDrawer.type !== 'permanent'"
        @click.stop="primaryDrawer.model = !primaryDrawer.model"
      ></v-app-bar-nav-icon>
      <v-toolbar-title><span 
        v-if="appState.userLoggedIn && appState.user.appname">{{appState.user.appname}}</span><span
        v-else>Roanuz Accounts</span></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-switch
        v-model="appState.roundedFigure"
        label="Rounded"
        @change="onRoundedFigureUpdated"
        hide-details
      ></v-switch>
      <v-divider vertical inset class="pr-2"></v-divider>
      <v-switch
        class="pl-2"
        v-model="appState.currencyConv.selected.enable"
        :label="appState.currencyConv.selected.name"
        @change="onConverstaionUpdated"
        hide-details
      ></v-switch>
      <div 
        v-if="appState.currencyConv.selected.enable"
        class="fixed-currency-width">
        <v-text-field
        v-model="appState.currencyConv.selected.amount"
        hide-details
        max-width="40" 
        type="number"
        @change="onConverstaionUpdated"
        ></v-text-field>
      </div>
    </v-app-bar>

    <v-content>
      <router-view class="page-content"/>
    </v-content>

    <v-footer :inset="footer.inset" app>
      <v-layout>
        <v-flex>
          <span class="px-4">&copy; Roanuz {{ new Date().getFullYear() }}</span>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<style lang="scss" src="./assets/scss/themes.scss"></style>
<style lang="scss" scoped>
  .fixed-currency-width {
    width: 80px;
    padding-left: 5px;
  }
</style>

<script>
export default {
  data: () => ({
    primaryDrawer: {
      model: null
    },
    footer: {
      inset: true
    }
  }),
  methods: {
    onConverstaionUpdated () {
      this.appState.currencyConv.saveToCache()
      // console.log('Changed',
      // this.appState.currencyConv.selected.enable,
      // this.appState.currencyConv.selected.amount)
    },
    onRoundedFigureUpdated () {
    }
  }
};
</script>